// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1n_e_","head":"ProcedureTableInfo_head__Ku3Nv"};